import { useQuery } from '@tanstack/react-query';
import { getInvitedByEmailMembers } from '~apis/member';

export const USE_GET_COMPANY_INVITED_USERS_QUERY = {
  default: (companyId: string) => ['invited-members', companyId],
};
export default function useInvitedMembersQuery(companyId?: string) {
  return useQuery(
    USE_GET_COMPANY_INVITED_USERS_QUERY.default(companyId as string),
    () => getInvitedByEmailMembers(companyId as string),
    {
      enabled: !!companyId,
    },
  );
}
